import React from 'react';
import PropTypes from 'prop-types';
import theme from 'theme/theme';
import {
    getBookingStatus,
    STATUS_CANCELLED,
    STATUS_COMPLETED,
    STATUS_ERROR,
    STATUS_PENDING,
    STATUS_SPLIT,
    STATUS_UNDER_REVIEW,
} from 'helpers/booking';
import StatusLabelField from 'components/show/StatusLabelField';

const statusColours = {
    [STATUS_CANCELLED]: {
        background: theme.palette.tomato,
    },
    [STATUS_COMPLETED]: {
        background: theme.palette.mossGreen,
    },
    [STATUS_ERROR]: {
        background: theme.palette.tomato,
    },
    [STATUS_PENDING]: {
        background: theme.palette.gray,
    },
    [STATUS_SPLIT]: {
        background: theme.palette.irisBlue,
    },
    [STATUS_UNDER_REVIEW]: {
        background: theme.palette.darkOrange,
    },
};

const BookingStatus = (props) => {
    const {
        record,
    } = props;

    const status = getBookingStatus(record);

    return <StatusLabelField
        background={ statusColours[status] ? statusColours[status].background : theme.palette.gray }
        label={ status }
    />;
};

BookingStatus.propTypes = {
    record: PropTypes.shape({
        cancelled_at: PropTypes.string,
        reservation_status: PropTypes.string.isRequired,
    }).isRequired,
};

export default BookingStatus;



// WEBPACK FOOTER //
// ./src/pages/bookings/show/BookingStatus.js